import React from "react";
import { Link } from "react-router-dom";
import logoLight from "../../assets/images/logo-light.png";

// Background from public folder so path is reliable (avoids AVIF/space-in-filename issues)
const authBgUrl = `${process.env.PUBLIC_URL || ""}/images/auth-bg.avif`;

/**
 * Premium split-screen auth layout: brand panel (left) + form panel (right).
 * Background image behind logo, soft colors, large logo.
 */
const ParticlesAuth = ({ children }) => {
  return (
    <div className="auth-split min-vh-100 d-flex flex-column flex-lg-row">
      {/* Left: Brand panel - visible only on lg+ */}
      <div className="auth-split-brand order-2 order-lg-1 d-none d-lg-flex flex-column justify-content-center align-items-center text-center p-5">
        <div className="auth-split-brand-bg-img" style={{ backgroundImage: `url(${authBgUrl})` }} aria-hidden="true" />
        <div className="auth-split-brand-bg" />
        <div className="auth-split-brand-dots" />
        <div className="auth-split-brand-glow auth-split-brand-glow-1" />
        <div className="auth-split-brand-glow auth-split-brand-glow-2" />
        <div className="auth-split-brand-fade" aria-hidden="true" />
        <div className="auth-split-brand-content position-relative">
          <Link to="/" className="d-inline-block mb-4">
            <img src={logoLight} alt="Precious Food" className="auth-split-logo" />
          </Link>
          <h1 className="auth-split-title text-white fw-bold mb-2">Precious Food</h1>
          <p className="auth-split-tagline text-white-50 mb-0">
            Manage your inventory, ledger, and operations in one place.
          </p>
        </div>
      </div>

      {/* Right: Form panel - form in a fixed-width box */}
      <div className="auth-split-form order-1 order-lg-2 d-flex align-items-center justify-content-center p-4 p-lg-5 flex-grow-1">
        <div className="auth-split-form-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ParticlesAuth;
